import { Dispatch, FC, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import useScreenSize from "../../custom-hooks/base-hooks/useScreenSize";
import HouseIconSVG from "../resources/svg/HouseIconSVG";
import DocumentsIconSVG from "../resources/svg/DocumentsIconSVG";
import BurgerMenuIconSVG from "../resources/svg/functional/BurgerMenuIconSVG";
import CustomBurgerMenu from "../../custom-components/CustomBurgerMenu";
import OneTimeWorkLogoSVG from "../resources/svg/logos/OneTimeWorkLogoSVG";

interface UnAuthHeaderVersionProps {
    setBackgroundBlur: Dispatch<SetStateAction<boolean>>;
    backgroundBlur: boolean;
}

const UnAuthHeader: FC<UnAuthHeaderVersionProps> = (props) => {
    const { upTo650, moreOrEqual650, upTo1024 } = useScreenSize();
    const { t } = useTranslation();
    const location = useLocation();

    const isMainPage = location.pathname === "/";
    const isCatalogPage = location.pathname === "/catalog";

    return (
        <header className="relative dmin2:h-[110px] td2:h-[80px] ti4:h-[78px] tmax4:h-[110px] dmin2:py-[30px] td4:py-[16px] tmax4:py-[12px] border-b border-b-backgroundButton">
            <div className="absolute flex justify-between items-center left-0 right-0 dmin2:mx-auto di6:mx-[26px] ti6:mx-8 ti7:mx-5 tmax4:mx-[15px] dmin2:max-w-[1280px] di6:min-w-[960px] ti6:min-w-[725px]">
                <Link to="/">
                    <OneTimeWorkLogoSVG className="td4:w-[120px] tmax4:w-[100px]" />
                </Link>
                {moreOrEqual650 && (
                    <p className="dmin2:H20B di6:H16B td2:H14B tmax1:H12B text-textWhite text-center dmin2:w-[523px] di6:w-[380px] ti6:w-[280px] ti7:w-[210px]">
                        {t("common.ads")}
                    </p>
                )}
                <div className="flex items-center">
                    <div className="tmax3:hidden mr-8">
                        <Link
                            to="/catalog"
                            className={`dmin2:H16B dmax2:H14B mr-6 transition duration-300 ${
                                isCatalogPage ? "text-textWhite" : "text-textFaded hover:text-textWhite"
                            }`}
                        >
                            {t("common.catalog")}
                        </Link>
                        <Link
                            to="/"
                            className={`dmin2:H16B dmax2:H14B mr-6 transition duration-300 ${
                                isMainPage ? "text-textWhite" : "text-textFaded hover:text-textWhite"
                            }`}
                        >
                            {t("common.main")}
                        </Link>
                    </div>
                    <Link
                        to="/login"
                        className="dmin2:H16B td2:H14B tmax1:H12B text-textWhite bg-primaryBlue hover:bg-primaryBlueFocused dmin2:w-[275px] td2:w-[231px] tmax1:w-[202px] dmin2:h-[50px] td2:h-[40px] tmax1:h-[37px] dmax5:mr-4 rounded-xl dmax2:rounded-lg flex justify-center items-center transition duration-300"
                    >
                        <div className="mb-[2px]">{t("common.authButton")}</div>
                    </Link>
                    {upTo1024 && (
                        <CustomBurgerMenu
                            backgroundBlur={props.backgroundBlur}
                            setBackgroundBlur={props.setBackgroundBlur}
                            buttonElement={<BurgerMenuIconSVG className="cursor-pointer text-textFaded" />}
                            popupClassName="absolute z-10 bg-backgroundInput right-0 border border-backgroundButton top-12 tmax4:top-20 w-[275px] h-fit rounded-b-[7px] py-5 px-6 cursor-default"
                        >
                            <Link
                                to="/"
                                className="flex items-center cursor-pointer w-full pb-4 border-b border-b-textFaded group"
                            >
                                <HouseIconSVG className="w-8 dmax2:w-6 h-8 dmax2:h-6 mr-3 text-textFaded group-hover:text-textWhite" />
                                <span className="H20 dmax2:H16 group-hover:H20B dmax2:group-hover:H16B text-textWhite">
                                    {t("common.main")}
                                </span>
                            </Link>
                            <Link
                                to="/catalog"
                                className="flex items-center cursor-pointer w-full mt-[22px] dmax2:mt-[20px] group"
                            >
                                <DocumentsIconSVG className="w-8 dmax2:w-6 h-8 dmax2:h-6 mr-3 text-textFaded group-hover:text-textWhite" />
                                <span className="H20 dmax2:H16 group-hover:H20B dmax2:group-hover:H16B text-textWhite">
                                    {t("common.catalog")}
                                </span>
                            </Link>
                        </CustomBurgerMenu>
                    )}
                </div>
            </div>
            {upTo650 && (
                <div className="absolute left-0 right-0 top-[76px] mx-auto flex justify-center">
                    <p className="H12B text-textWhite text-center mmax2:max-w-[380px]">{t("common.ads")}</p>
                </div>
            )}
        </header>
    );
};

export default UnAuthHeader;
